import styles from "./SubScreenTitle.module.scss";

const SubScreenTitle = ({ children }) => {
  return (
    <section className={" "}>
      <h2 className={styles.subscreentitle}>{children}</h2>
    </section>
  );
};
export default SubScreenTitle;
